
import API from '@/api/api_sign'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
created(){
this.dos();
},
directives: {
TransferDom
},
components: {
XInput,
XButton,
Group,
Cell,
Alert,
Loading,
XButton,
Box,
Toast,
XDialog,Tabbar, TabbarItem,CheckIcon
},
data () {
return {
show:false,
loading:false,
datas:{},
entId:'',
customerNo:'',
bankNo:'',
subBranch:'',
subBranchs:'',
cardNo:'',
options:[],
isagree:false,
}
},
methods: {
dos(){
API.entInfo({customerNo:this.$route.query.customerNo}).then((res)=>{
if (res.code == '000000') {
this.datas = res.data;
if(res.data.signatureStatus=="1"&&res.data.paymentStatus=="0"){
this.$router.push({path:`/checkbusinessm/1`,query:{customerNo:this.$route.query.customerNo}})
}
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})

},
submit(){
let _this =this;
if(this.datas.showFlag != '1'){
if (this.cardNo === "") {
this.$vux.toast.show({
type:'cancel;',
text:'对公账户号不能为空'
});
return;
}
if (this.bankNo === "") {
this.$vux.toast.show({
type:'cancel;',
text:'对公账户开户行不能为空	'
});
return;
}
if (this.subBranch === "") {
this.$vux.toast.show({
type:'cancel;',
text:'对公账户联行号不能为空'
});
return;
}
}
if(this.isagree==false){
this.$vux.toast.show({
type:'cancel;',
text:'请勾选协议'
});
return;
}
let param = new FormData();
param.append("customerNo",this.$route.query.customerNo);
if(this.datas.showFlag != '1'){
param.append("cardNo",this.cardNo);
param.append("subBranch",this.subBranchs);
param.append("bankNo",this.bankNo);
}
API.nameent(param).then((res)=>{
if (res.code == '000000') {
if(this.datas.showFlag!='1'){
this.$router.push({path:`/checkbusinessm/1`,query:{customerNo:this.$route.query.customerNo}})
}else{

this.$vux.toast.show({
type:'success',
text:'四要素验证成功！'
});
setTimeout(function(){
_this.$router.go(-1)
}, 2000);
}
}else{
console.log(this.datas.showFlag);
if(this.datas.showFlag!='1'){
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}else{
this.$vux.toast.show({
width:'220px',
time:'3000',
type:'cancel',
text:'四要素验证失败，请致电400-178-7833 更新账户信息'
});
}
}
})


},
remoteMethod(query){
if (query !== '') {
this.loading = true;
API.listsubbranch({subbranch:query}).then((res)=>{
if (res.code == '000000') {
this.loading = false;
this.options = res.data;
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
} else {
this.options = [];
}
},
get(val){
for(let i in this.options){
if(this.options[i].id==val){
this.bankNo = this.options[i].lineNumber;
this.subBranchs = this.options[i].subbranch
}
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/checkBusiness.vue